'use client';

import {
  MY_LOADS_BIDS_PAGE_PATH,
  MY_LOADS_BOOKED_PAGE_PATH,
  MY_LOADS_SAVED_PAGE_PATH,
  MY_LOADS_RECENTLY_VIEWED_PAGE_PATH,
} from '~/app/pages';
import NavLink from '~/app/(authenticated)/_ui/NavItems/NavLink';
import useIsActivePathname from '~/app/(authenticated)/_lib/useIsActivePath';

export default function MyLoadsNavLink() {
  const isActive = [
    useIsActivePathname(MY_LOADS_RECENTLY_VIEWED_PAGE_PATH),
    useIsActivePathname(MY_LOADS_SAVED_PAGE_PATH),
    useIsActivePathname(MY_LOADS_BIDS_PAGE_PATH),
    useIsActivePathname(MY_LOADS_BOOKED_PAGE_PATH),
  ].some((isActive) => isActive);

  return (
    <NavLink
      href={MY_LOADS_RECENTLY_VIEWED_PAGE_PATH}
      label="My Loads"
      active={isActive}
    />
  );
}
